import ContactForm from './ContactForm';
import { add_contact } from '../api/contact_api';
import '../styles/Common.css';


const AddContact = ({ onCancel, onClose, onContactAdded }) => {
    const handleSubmit = async (e) => {
        console.log("here");
        e.preventDefault();
        const contact = {
            full_name: e.target.full_name.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
        };
        try {
            await add_contact(contact);
            alert('איש הקשר נוסף בהצלחה!');
            if (onContactAdded) onContactAdded();
        } catch (err) {
            console.log(err);
            alert('הוספת איש הקשר נכשלה');
        }
    };
    return (
        <div className="contacts-tab">
            <div className="contacts-header">
                <h2 style={{ color: '#150F6B', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        fill="none" stroke="#150F6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M4 21v-2a4 4 0 0 1 3-3.87" />
                        <circle cx="12" cy="7" r="4" />
                    </svg>
                    הוספת איש קשר
                </h2>
                <button id="close-btn" className="btn" title="סגור" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            </div>
            <ContactForm onCancel={onCancel} onSubmit={handleSubmit}/>
        </div>
    );
};

export default AddContact;
